import { IBuildCanonicalPage } from '~types/index'

const buildCanonicalPage = ({ link, name, params }: IBuildCanonicalPage) => ({
  name,
  icon: 'tag',
  display: false,
  position: 'header',
  link: {
    ...link,
    path: link.canonical,
    external: false,
    target: '_self',
  },
  params,
})

export { buildCanonicalPage }
